import { action, NetbankingAPI } from "aaa";
import { observable } from "mobx";
import { ContactsStore } from "stores/ContactsStore";
import { NetbankingAPIClient } from "../../network/APIClient";
import { IEcommerce, IEcommercePutResponse } from "../../types/profile";

export class GIGStore {
    contactsStore = new ContactsStore();
    @observable isActivating: boolean = false;
    @observable putEcommerceResponse?: IEcommercePutResponse;
    @observable getEcommerceResponse?: IEcommerce;

    isLoading(): boolean {
        return this.contactsStore.isLoading || !this.getEcommerceResponse || this.isActivating;
    }

    activate = async () => {
        if (this.contactsStore.selectedEmailAddressId) {
            const target = NetbankingAPI.putEcommerce({
                avisoEmailId: this.contactsStore.selectedEmailAddressId,
                cie: "ACTIVE"
            });

            try {
                this.isActivating = true;
                this.putEcommerceResponse = await NetbankingAPIClient.requestType(target);
                this.isActivating = false;
            } catch (error) {
                this.isActivating = false;
                throw error;
            }
        }
    }

    @action async load() {
        await this.contactsStore.load();

        try {
            this.getEcommerceResponse = await NetbankingAPIClient.requestType(NetbankingAPI.getEcommerce());
        } catch (error) {
            throw error;
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/gig/GIGStore.tsx